import graphql from 'babel-plugin-relay/macro';

export const GET_SPECIALITIES_QUERY = graphql`
  query profileSpecialitiesQuery(
    $first: Int!
    $after: String
    $ordering: [SpecialityOrdering!]
    $filter: SpecialityFilter
  ) {
    specialities(first: $first, after: $after, ordering: $ordering, filter: $filter) {
      edges {
        node {
          id
          name
          practitionerType
          category
          translationKey
          connectOnly
          deletedAt
          updatedAt
          createdAt
          phasedOutAt
        }
      }
    }
  }
`;

export const GET_PROFILE_QUESTIONS_QUERY = graphql`
  query profileProfileQuestionsQuery {
    profileQuestions(first: 10) {
      edges {
        node {
          id
          question
          translationKey
          practitionerType
        }
      }
    }
  }
`;
